import React from 'react'
import CveDetails from './CveDetails'
import { ServiceDetails } from './ServiceDetails'
import { CampaignDetails } from './CampaignDetails'
import IndicatorDetails from './IndicatorDetails'
import { VulnerabilityDetails, cveColorTheme, v2StringMap, v3StringMap } from './VulnerabilityDetails'
import RecentActivity from './RecentActivity'
import AssociationDetails from './ActorPageDetails/AssociationDetails'
import TargetsDetails from './ActorPageDetails/TargetsDetails'
import SummaryDetails from './ActorPageDetails/SummaryDetails'
import GroupAssociationDetails from './ActorPageDetails/GroupAssociationDetails'
import { UpgradeContextProvider } from '@maui/freemium'
import { IconListGrid } from '../common/IconListGrid'
import MalwareDetails from '../details/MalwareDetails/MalwareDetails'

const SharedContext = ({ children }) => (
  <UpgradeContextProvider url="/upgrade" buttonText="Upgrade Now">
    {children}
  </UpgradeContextProvider>
)

const GroupAssociationDetailsView = React.forwardRef((props, ref) => (
  <SharedContext>
    <GroupAssociationDetails {...props} ref={ref} />
  </SharedContext>
))

const AssociationDetailsView = React.forwardRef((props, ref) => (
  <SharedContext>
    <AssociationDetails {...props} ref={ref} />
  </SharedContext>
))

const SummaryDetailsView = (props) => (
  <SharedContext>
    <SummaryDetails {...props} />
  </SharedContext>
)

const TargetsDetailsView = React.forwardRef((props, ref) => (
  <SharedContext>
    <TargetsDetails {...props} ref={ref} />
  </SharedContext>
))

const RecentActivityView = (props) => (
  <SharedContext>
    <RecentActivity {...props} />
  </SharedContext>
)

const MalwareDetailsView = (props) => (
  <SharedContext>
    <MalwareDetails {...props} />
  </SharedContext>
)

const CveDetailsView = (props) => (
  <SharedContext>
    <CveDetails {...props} />
  </SharedContext>
)

const VulnerabilityDetailsView = (props) => (
  <SharedContext>
    <VulnerabilityDetails {...props} />
  </SharedContext>
)

const ServiceDetailsView = (props) => (
  <SharedContext>
    <ServiceDetails {...props} />
  </SharedContext>
)

const CampaignDetailsView = (props) => (
  <SharedContext>
    <CampaignDetails {...props} />
  </SharedContext>
)

const IndicatorDetailsView = (props) => (
  <SharedContext>
    <IndicatorDetails {...props} />
  </SharedContext>
)

export {
  CampaignDetailsView,
  SummaryDetailsView,
  CveDetailsView,
  VulnerabilityDetailsView,
  MalwareDetailsView,
  ServiceDetailsView,
  IndicatorDetailsView,
  cveColorTheme,
  v2StringMap,
  v3StringMap,
  RecentActivityView,
  AssociationDetailsView,
  TargetsDetailsView,
  GroupAssociationDetailsView,
  IconListGrid,
}
